import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SIZES } from '../helper';

const resolveMargin = size => {
  const margin = {
    lg: "var(--size-spacing-05)",
    md: "var(--size-spacing-05)",
    sm: "var(--size-spacing-02)"
  };
  return margin[size] ? margin[size] : margin.lg;
};

const Root = styled.div.withConfig({
  displayName: "MessageContent__Root",
  componentId: "sc-p6cvjd-0"
})(["width:100%;margin-right:calc(", " + 32px);"], _ref => {
  let {
    size
  } = _ref;
  return resolveMargin(size);
});
const MessageContent = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest), children);
});
MessageContent.display = 'MessageContent';
MessageContent.defaultProps = {
  children: null,
  size: SIZES.LG
};
MessageContent.propTypes = {
  /**
   * @ignore
   * Sets the children, Usually is a string
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  size: PropTypes.oneOf([SIZES.SM, SIZES.MD, SIZES.LG])
};
export default MessageContent;